import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import T from '../../../app/Locale';
import Button from '../../Components/ComponentButton';
import Modal from './SelectPartnersModal';
const SelectPartnersButton = ({ partners, existingPartners }) => {
    const [showModal, toggleModal] = useState(false);
    return (_jsxs("div", { children: [_jsx(Button, { title: T.translate('partners.edit'), onClick: () => toggleModal(true) }), showModal && (_jsx(Modal, { title: T.translate('partners.title'), description: T.translate('partners.description'), partners: partners, existingPartners: existingPartners, cta: T.translate('partners.save'), showNone: false }))] }));
};
SelectPartnersButton.propTypes = {
    partners: PropTypes.array.isRequired,
    existingPartners: PropTypes.array.isRequired
};
export default SelectPartnersButton;
